import { useEffect, useRef, useState } from 'react'

import styles from './FilterableDropdown.module.scss'

const RateCodeDropdown = ({ value, options, onChangeValue, className }) => {
  const [isOpen, setOpen] = useState(false)
  const [searchString, setSearchString] = useState('')

  const node = useRef()

  const handleClickIn = value => {
    onChangeValue(value)
    setOpen(false)
  }

  const handleClickOutside = e => {
    if (node.current.contains(e.target)) {
      return
    }
    setOpen(false)
  }

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isOpen])

  return (
    <div className={styles.wrapper} ref={node}>
      <div
        className={[styles.dropdownHolder, className].join(' ')}
        onClick={() => setOpen(!isOpen)}
      >
        <div className={styles.select}>{value || 'Add rate code'}</div>
      </div>
      {isOpen && (
        <div className={styles.dialog}>
          {Object.keys(options).length > 12 && (
            <div className={styles.searchFilterHolder}>
              <input
                type="search"
                className={styles.searchFilter}
                value={searchString}
                onChange={e => setSearchString(e.target.value)}
                placeholder="Type to search"
                autoFocus
              />
            </div>
          )}
          {Object.keys(options)
            .sort((a, b) => options[b] - options[a])
            .filter(v => v.toUpperCase().includes(searchString.toUpperCase()))
            .map(v => (
              <Value
                isActive={v === value}
                key={v}
                rate={v}
                count={options[v]}
                handleClick={handleClickIn}
              />
            ))}
        </div>
      )}
    </div>
  )
}

const Value = ({ rate, handleClick, isActive, valueName }) => (
  <div
    className={isActive ? styles.rateActive : styles.rate}
    onClick={() => handleClick(rate)}
  >
    <div className={styles.rateName} title={rate}>
      {rate === 'any' ? `Any ${valueName}` : rate}
    </div>
  </div>
)

export default RateCodeDropdown
